import React, { forwardRef } from 'react';
import { ChoiceItem, IChoiceItem } from './ChoiceItem';
import './ChoiceList.less';
import { ChoiceSeparator } from './ChoiceSeparator';
import classNames from 'classnames';

interface IChoiceListProps {
  className: string;
  items: IChoiceItem[];
  isSideBar: boolean;
  showIllustrations: boolean;
  onChoose: (item: IChoiceItem) => void;
}

function getClassName(className?: string, isSingle?: boolean) {
  return classNames('dpc-content-choice-list', className, { 'dpc-content-choice-list--single': isSingle });
}

/**
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export const ChoiceList = forwardRef(
  (
    { items, isSideBar, onChoose, className, showIllustrations }: IChoiceListProps,
    ref: React.Ref<HTMLUListElement>
  ) => {
    if (items.length === 0) {
      return null;
    }

    if (items.length === 1) {
      return (
        <ul ref={ref} className={getClassName(className, true)}>
          <ChoiceSeparator orientation={isSideBar != null ? 'horizontal' : 'vertical'} hasLines={false} />
          <ChoiceItem
            item={items[0]}
            showIllustrations={showIllustrations}
            isInSidePanel={isSideBar}
            onChoose={onChoose}
          />
        </ul>
      );
    }

    return (
      <ul ref={ref} className={getClassName(className, false)}>
        {items.map((item, index) => (
          <React.Fragment key={item.id}>
            <ChoiceItem
              item={item}
              showIllustrations={showIllustrations}
              isInSidePanel={isSideBar}
              onChoose={onChoose}
            />
            {index !== items.length - 1 && <ChoiceSeparator orientation={isSideBar ? 'horizontal' : 'vertical'} />}
          </React.Fragment>
        ))}
      </ul>
    );
  }
);
